<template lang="html">
  <div>
    <md-toolbar ref="mainToolbar" id="mainToolbar">
      <md-layout md-row md-gutter="16">
        <md-layout md-flex="5" style="margin:auto">
          <md-button class="md-icon-button" @click.native="toggleSidenav">
            <md-icon style="font-size:30px;">menu</md-icon>      
          </md-button>
        </md-layout>
        <md-layout md-hide-small>
          <span @click="goToCatalogo" style="cursor:pointer;">
            <!-- <img id="logo-toolbar" src="../../assets/img/reyBotanero.png" alt=""> -->
            <!-- <img id="logo-toolbar" src="../../assets/img/ixoye.png" alt=""> -->
            <!-- <img id="logo-toolbar" src="../../assets/img/alitas.jpg" alt=""> -->
            <!-- <img id="logo-toolbar" src="../../assets/img/pinjaque.png" alt=""> -->
            <!-- <img id="logo-toolbar" src="../../assets/img/farmacia.jpeg" alt=""> -->
            <!-- <img id="logo-toolbar" src="../../assets/img/2cajas.png" alt=""> -->
            <!-- <img id="logo-toolbar" src="../../assets/img/Compart-white.png" alt=""> -->
            <img id="logo-toolbar" src="../../assets/img/electrikmex.png" alt="">
          </span>
        </md-layout>
 
        <md-layout md-hide-medium-and-up md-align="center">
          <span @click="goToCatalogo" style="cursor:pointer;">
            <!-- <img id="logo-toolbar" src="../../assets/img/reyBotanero.png" style=" margin-left: 30px" alt=""> -->
            <!-- <img id="logo-toolbar" src="../../assets/img/ixoye.png" style=" margin-left: 30px" alt=""> -->
            <!-- <img id="logo-toolbar" src="../../assets/img/farmacia.jpeg" style=" margin-left: 30px" alt=""> -->
            <!-- <img id="logo-toolbar" src="../../assets/img/Compart-white.png" alt=""> -->
            <!-- <img id="logo-toolbar" src="../../assets/img/2cajas.png" style=" margin-left: 30px" alt=""> -->
          </span>
        </md-layout>
        
        <!-- <md-layout md-flex md-align="center" md-hide-small md-hide-xsmall>
            <md-input-container style="margin:auto; width:100%" >
              <label>Buscar</label>
              <md-input v-model="busqueda" @blur="filterBySubstring"></md-input>
              <md-icon @click.native="filterBySubstring">search</md-icon>
            </md-input-container>
        </md-layout> -->


        
          
          <div class="toolbar_user" md-row>
          
            <md-layout md-align="end">
              
              <div>
                
                <md-menu md-align-trigger md-direction="bottom right" ref="menuCarrito">
                  <md-button md-menu-trigger class="cart_button">
                    <img class="cartImageMenu" id=""
                    src="../../assets/img/opcionA.png" alt="" width="30"/>
                    <!-- <img class="cartImageMenu" id=""
                    src="../../assets/img/mini_opcionB.png" alt="" width="30"/> -->
                  <!-- <md-icon style="font-size:30px;">shopping_cart</md-icon>       -->
                  <div class="cart_number" v-if="cartItems.length > 0">
                    <label>{{cartItems.length}}</label>
                  </div>
                </md-button>

                  <md-menu-content style="width:200px;" class="menu-cart">
                    <md-menu-item>
                      <div style="max-height:200px; overflow:auto; width:100%">
                        <md-list class="custom-list md-triple-line">
                          <md-list-item v-if="cartItems.length === 0">
                            <div>
                              No se han agregado articulos
                            </div>
                          </md-list-item>
                          <md-list-item v-for="(cart, index) in cartItems">
                            <div style="margin-right:10px;">
                              <img class="cartImageMenu" :id="`img${index}`" 
                                v-if="cart.foto && cart.foto.replace(/ /g,'') !== '' && cart.foto.replace(/ /g,'') !== null"
                                :src="`${parametros.ruta_imagen}${cart.foto}`" />
                                <img class="cartImageMenu" id="" v-else src="../../assets/img/SuperticketElefanteC.png" alt="No se encontro la imagen" />
                            </div>

                            <div class="md-list-text-container">
                              <span>{{cart.descripcion}}</span>
                              <span>cantidad: {{cart.cantidad}}</span>
                              <div style="font-size:18px; opacity: .8; font-weight:bold">{{toMoney(cart.precioTotal + cart.impuestos)}}</div>
                            </div>

                            <md-button class="md-icon-button md-list-action" @click.native="deleteFromCart(index)" style="margin-right:5px">
                              <md-icon class="md-primary">delete</md-icon>
                            </md-button>

                            <md-divider class="md-inset"></md-divider>
                          </md-list-item>
                        </md-list>
                      </div>
                    </md-menu-item>
                    <md-menu-item >
                      <div v-if="subtotal !== 0" style="font-size:18px; opacity: .8; font-weight:bold; width:100%; text-align:right; padding-right: 8px">
                        Total: {{toMoney(subtotal)}}
                      </div>
                    </md-menu-item>
                    <md-menu-item>
                      <div style="text-align: right; width:100%">
                        <md-button class="md-primary md-raised btn-carrito" @click.native="goToCart">Ir al Carrito</md-button>
                      </div>
                    </md-menu-item>
                  </md-menu-content>
                </md-menu>

                
              </div>
              <md-layout>
                <!-- <md-layout v-if="!isUserLogged" md-flex>
                  <md-button @click.native="openModal('registroDialog')" class="LogInLabel" >Registrarse</md-button>
                </md-layout> -->
                <md-layout v-if="!isUserLogged"  md-flex>
                  <md-button @click.native="goLogin()" class="LogInLabel">Iniciar sesión</md-button>
                </md-layout>
                <md-menu md-align-trigger md-direction="bottom left"  v-if="isUserLogged">
                  <md-button md-menu-trigger>
                    {{nombreUsuario}}
                    <md-icon>perm_identity</md-icon>
                  </md-button>

                  <md-menu-content>
                    <md-menu-item @click.native="goToMyCuenta">Mi cuenta</md-menu-item>
                    <md-menu-item @click.native="logout">Cerrar sesión</md-menu-item>
                  </md-menu-content>
                </md-menu>
                <!-- <h4 v-if="isUserLogged">{{nombreUsuario}}</h4>
                <div id="userFace" v-if="isUserLogged">
                  <md-icon>perm_identity</md-icon>
                </div> -->
              </md-layout>

            </md-layout>

          </div>


      </md-layout>
      
    </md-toolbar>

    <md-dialog ref="logInDialog" id="logInDialog">
      <md-dialog-title style="padding:0">
        <md-toolbar>
          <div class="md-title">Iniciar sesión</div>
        </md-toolbar>
      </md-dialog-title>
      <md-dialog-content>
        <md-layout md-column>
          <md-input-container>
            <md-icon>perm_identity</md-icon>
            <label>Nombre de usuario</label>
            <md-input v-model="usuario.usuario"></md-input>
          </md-input-container>
          <md-input-container>
            <md-icon>lock_outline</md-icon>
            <label>Contraseña</label>
            <md-input v-model="usuario.contrasena" type="password"></md-input>
          </md-input-container>
          <span @click="openModal('PassDialog')">
            <div id="ForgotPassword">¿Olvido su contraseña?</div>
          </span>
        </md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        <md-layout>
          <md-layout md-align="start">
            <md-button class="md-accent" id="cancelar" @click.native="openModal('registroDialog')" >Registrarse</md-button>
          </md-layout>
          <md-layout md-align="end">
            <md-button class="md-accent" id="cancelar" @click.native="closeModal('logInDialog')">Cancelar</md-button>
            <md-button class="md-primary md-raised" id="entrar" @click.native="logIn">Entrar</md-button>
          </md-layout>
        </md-layout>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog ref="registroDialog" id="registroDialog">
      <md-dialog-title style="padding:0">
        <md-toolbar>
          <div class="md-title">Registro</div>
        </md-toolbar>
      </md-dialog-title>
      <md-dialog-content v-if="parametros">
        
        <md-layout md-gutter="16" v-if ="parametros.ocultar_precios === 0 || parametros.ocultar_precios === '0'">
          <!-- <md-layout md-flex="100">
            <h2>Datos de Usuario</h2>
          </md-layout> -->
          <md-layout md-flex="100">
            <md-input-container>
              <label>Nombre de Usuario</label>
              <md-input required v-model="usuarioRegistro.cliente.usuario"></md-input>
            </md-input-container>
          </md-layout>
          <md-layout md-flex="100">
            <md-input-container>
              <label>Email</label>
              <md-input required v-model="usuarioRegistro.cliente.email"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Nombre Fiscal</label>
              <md-input required v-model="usuarioRegistro.cliente.nombre"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Nombre Comercial</label>
              <md-input v-model="usuarioRegistro.cliente.comercial"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>RFC</label>
              <md-input v-model="usuarioRegistro.cliente.rfc"></md-input>
            </md-input-container>
          </md-layout>

          <!-- <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Dirección</label>
              <md-input required v-model="usuarioRegistro.cliente.direccion"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="25" md-flex-small="50" md-flex-xsmall="50">
            <md-input-container>
              <label>Num Exterior</label>
              <md-input required v-model="usuarioRegistro.cliente.numext"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="25" md-flex-small="50" md-flex-xsmall="50">
            <md-input-container>
              <label>Num interior</label>
              <md-input v-model="usuarioRegistro.cliente.numint"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Pais</label>
              <md-input required v-model="usuarioRegistro.cliente.pais"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Estado</label>
              <md-input required v-model="usuarioRegistro.cliente.entfed"></md-input>
            </md-input-container>
          </md-layout>


          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Ciudad</label>
              <md-input required v-model="usuarioRegistro.cliente.poblacion"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Colonia</label>
              <md-input v-model="usuarioRegistro.cliente.colonia"></md-input>
            </md-input-container>
          </md-layout> -->

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Telefono</label>
              <md-input type="number" v-model="usuarioRegistro.cliente.telefono" maxlength="5"></md-input>
            </md-input-container>
          </md-layout>

          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container>
              <label>Contraseña</label>
              <md-input required type="password" v-model="usuarioRegistro.sTShop.contrasena"  @blur.native="checkPassword"></md-input>
            </md-input-container>
          </md-layout>
          
          <md-layout md-flex="50" md-flex-small="100" md-flex-xsmall="100">
            <md-input-container >
              <label>Confirma Contraseña</label>
              <md-input required type="password" v-model="usuarioRegistro.confirmaContrasena" @blur.native="checkPassword"></md-input>
            </md-input-container>
            
          </md-layout>

          </md-layout>
        </md-layout>
        <md-layout v-else>
          Favor de comunicarse al 
          {{empresa.telefono + ' '}} 
          o enviar un correo a {{empresa.email  + ' '}}
          para solicitar su registro
        </md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-accent" id="cancelar" @click.native="closeModal('registroDialog')">Cerrar</md-button>
        <md-button class="md-primary md-raised" id="entrar" @click.native="validateRegistro" v-if ="parametros.ocultar_precios === 0 || parametros.ocultar_precios === '0'">Registrarse</md-button>
      </md-dialog-actions>
    </md-dialog>


    <md-dialog ref="PassDialog" id="PassDialog">
      <md-dialog-title style="padding:0">
        <md-toolbar>
          <div class="md-title">Recuperar Contraseña</div>
        </md-toolbar>
      </md-dialog-title>
      <md-dialog-content>
        <md-layout md-column>
          <md-input-container>
            <md-icon>perm_identity</md-icon>
            <label>Email</label>
            <md-input v-model="emailRecupera"></md-input>
          </md-input-container>
        </md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        <md-layout>
          <md-layout md-align="end">
            <md-button class="md-accent" id="cancelar" @click.native="closeModal('PassDialog')">Cancelar</md-button>
            <md-button class="md-primary md-raised" id="entrar" @click.native="resetPass">Recuperar Contraseña</md-button>
          </md-layout>
        </md-layout>
      </md-dialog-actions>
    </md-dialog>

  </div>
</template>
<script type="text/javascript">
  import { toMoney } from '../../common/functions/helpers';
  import Email from '../../common/functions/smtp'

  export default {
    props: {
      // nombreUsuario: String,
    },
    data() {
      return {
        resourceUsuario: this.$api.usuario(this.$resource),
        resourceCliente: this.$api.cliente(this.$resource),
        busqueda: null,
        nombreUsuario: '',
        usuario: {
          usuario: '',
          contrasena: '',
        },
        // cliente: {},
        usuarioRegistro: {
          confirmaContrasena: '',
          cliente: {
            email: '',
            nombre:'',
            comercial: '',
            rfc: '',
            direccion: '',
            numext: '',
            numint: '',
            pais: '',
            entfed: '',
            poblacion: '',
            colonia: '',
            cp: '',
          },
          sTShop: {
            contrasena: '',
          },
        },
        isUserLogged: false,
        passwordEqual: true,
        cartItems: [],  
        emailRecupera: '',
        parametros: {},
        empresa: {}
      };
    },
    computed: {
      isPasswordEqual() {
        return this.passwordEqual ? '' : 'md-input-invalid';
      },
      cart() {
        return localStorage.getItem('cart');
      },
      cliente() {
        return localStorage.getItem('cliente');
      },
      subtotal() {
        let total = 0;
        this.cartItems.forEach((element) => {
          total += element.precioTotal + element.impuestos;
        });
        return total;
      },
    },
    components: {
    },
    methods: {
      toMoney,
      getParametros() {
        this.resourceCliente.parametros()
          .then((response) => {
            const parametros = {};
            response.body.data.forEach((el) => {
              switch (el.descripcion.trim()) {
                case 'almacen':
                  parametros.almacen = el.parametro.trim();
                  break;
                case 'pago':
                  parametros.pago = el.parametro.trim();
                  break; 
                case 'envio':
                  parametros.envio = el.parametro.trim();
                  break;
                case 'ruta_imagen':
                  parametros.ruta_imagen = el.parametro.trim();
                  break;
                case 'existencia_negativa':
                  parametros.existencia_negativa = el.parametro.trim();
                  break;
                case 'sitio':
                  parametros.sitio = el.parametro.trim();
                  break;
                case 'subdepto_descr':
                  parametros.subdepto_descr = el.parametro.trim();
                  break;
                case 'categoria':
                  parametros.categoria = el.parametro.trim();
                  break; 
                case 'categoria_descr':
                  parametros.categoria_descr = el.parametro.trim();
                  break;
                case 'tipoproducto':
                  parametros.tipoproducto = el.parametro.trim();
                  break;
                case 'tipoproducto_descr':
                  parametros.tipoproducto_descr = el.parametro.trim();
                  break;
                case 'ano':
                  parametros.ano = el.parametro.trim();
                  break;
                case 'ano_descr':
                  parametros.ano_descr = el.parametro.trim();
                  break;
                case 'departamento':
                  parametros.departamento = el.parametro.trim();
                  break; 
                case 'departamento_descr':
                  parametros.departamento_descr = el.parametro.trim();
                  break;
                case 'subdepto':
                  parametros.subdepto = el.parametro.trim();
                  break;
                case 'envio_por_cobrar':
                  parametros.envio_por_cobrar = el.parametro.trim();
                  break; 
                case 'metodo_envio':
                  parametros.metodo_envio = el.parametro.trim();
                  break;
                case 'porcentaje_envio':
                  parametros.porcentaje_envio = el.parametro.trim();
                  break; 
                case 'articulo_envio':
                  parametros.articulo_envio = el.parametro.trim();
                  break; 
                case 'ocultar_precios':
                  parametros.ocultar_precios = el.parametro.trim();
                  break; 
                case 'pagos_meses':
                  parametros.pagos_meses = el.parametro.trim();
                  break;                
              }
            })
            localStorage.setItem('parametros', JSON.stringify(parametros));
            this.parametros = parametros;
          })
          .catch((err) => {
            this.$error(this, err);
          });
      },
      validateRegistro () {
        if(!this.usuarioRegistro.cliente.usuario && !this.usuarioRegistro.cliente.usuario.length > 0){
          this.$toast.create('El campo usuario es obligatorio', 'snack', 3E3);
          return;
        } 
        if(!this.usuarioRegistro.cliente.email && !this.usuarioRegistro.cliente.email.length > 0){
          this.$toast.create('El campo email es obligatorio', 'snack', 3E3);
          return;
        } 
        if(!this.usuarioRegistro.cliente.nombre && !this.usuarioRegistro.cliente.nombre.length > 0){
          this.$toast.create('El campo Nombre fiscal es obligatorio', 'snack', 3E3);
          return;
        } 
        // if(!this.usuarioRegistro.cliente.comercial && !this.usuarioRegistro.cliente.comercial.length > 0){
        //   this.$toast.create('El campo Nombre Comercial es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.rfc && !this.usuarioRegistro.cliente.rfc.length > 0){
        //   this.$toast.create('El campo RFC es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.direccion && !this.usuarioRegistro.cliente.direccion.length > 0){
        //   this.$toast.create('El campo Dirección es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.numext && !this.usuarioRegistro.cliente.numext.length > 0){
        //   this.$toast.create('El campo Num Exterior es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.pais && !this.usuarioRegistro.cliente.pais.length > 0){
        //   this.$toast.create('El campo País es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.entfed && !this.usuarioRegistro.cliente.entfed.length > 0){
        //   this.$toast.create('El campo Estado es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.poblacion && !this.usuarioRegistro.cliente.poblacion.length > 0){
        //   this.$toast.create('El campo Población es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        // if(!this.usuarioRegistro.cliente.cp && !this.usuarioRegistro.cliente.cp.length > 0){
        //   this.$toast.create('El campo Codigo Postal es obligatorio', 'snack', 3E3);
        //   return;
        // } 
        if(!this.usuarioRegistro.sTShop.contrasena && !this.usuarioRegistro.sTShop.contrasena.length > 0){
          this.$toast.create('El campo Contraseña es obligatorio', 'snack', 3E3);
          return;
        } 
        if(!this.usuarioRegistro.confirmaContrasena && !this.usuarioRegistro.confirmaContrasena.length > 0){
          this.$toast.create('El campo Confirma Contraseña es obligatorio', 'snack', 3E3);
          return;
        }
        if (!this.passwordEqual) {
          alert('El campo contraseña y confirmar contraseña no coinciden, Favor de Revisar estos campos');
          return;
        }
        this.registro();
      },
      setCart() {
        debugger
        this.cartItems = window.cart;
      },
      setCliente() {
        const cliente = JSON.parse(localStorage.getItem('cliente'));
        this.isUserLogged = true;
        this.nombreUsuario = cliente.cliente.comercial ? cliente.cliente.comercial : cliente.cliente.nombre;
        // this.cliente = window.cliente;
      },
      openModal(ref) {
        this.$refs[ref].open();
      },
      closeModal(ref) {
        this.$refs[ref].close();
      },
      checkPassword() {
        this.passwordEqual =
          this.usuarioRegistro.sTShop.contrasena === this.usuarioRegistro.confirmaContrasena;
      },
      deleteFromCart(index) {
        this.cartItems.splice(index, 1);
        window.cart = this.cartItems;
        localStorage.setItem('cart', JSON.stringify(this.cartItems));
      },
      goLogin(){
        this.$router.push({ name: 'login' });
        
      },
      logout() {
        this.isUserLogged = false;
        localStorage.removeItem("cliente");
        // const route = this.$route.name;
        this.$router.go(this.$router.currentRoute);
        
      },
      logInAuth() {
        const usuario = {
          email: "stshop@compart.com.mx",
          password: "Compart33461"
        };
        this.resourceUsuario.logIn(usuario)
          .then((response) => {
            localStorage.setItem('token', response.body.access_token);
            this.closeModal('logInDialog'); 
          })
          .catch((err) => {
            this.$toast.create('Usuario o Contraseña incorrectos', 'snack', 3E3);
          });
      },
      logIn() {
        this.resourceCliente.logIn(this.usuario)
          .then((response) => {
            this.nombreUsuario = response.body.cliente.comercial;
            this.isUserLogged = true;
            localStorage.setItem('cliente', JSON.stringify(response.body));
            // const route = this.$route.name;
            this.$router.push({ name: 'inicial' });
            this.$toast.create('Se inicio sesión correctamente', 'snack', 3E3);
            this.closeModal('logInDialog');
          })
          .catch((err) => {
            this.$toast.create('Usuario o Contraseña incorrectos', 'snack', 3E3);
          });
      },
      resetPass() {
        const email = this.emailRecupera
        this.resourceCliente.RecuperaPass({email})
          .then((response) => {
            this.enviarMailPassword(response.body);
            this.closeModal('PassDialog')
          })
          .catch((err) => {
            this.$toast.create('No se encontro un usuario con ese email', 'snack', 3E3);
          });
      },
      enviarMailPassword(data){   
        const mail = `<html><head></head><body><div style='margin-left:auto; margin-right: auto; width:650px;'><table style='width:650px; font-size:14px'><tr><td><img style='max-height: 90px; max-width: 350px' src='${this.parametros.ruta_imagen}${data.empresa.foto}' alt='No se encontro la imagen' /></td><td style='text-align: right'><b>${data.empresa.nombre}</b>  <br>${data.empresa.direccion} ${data.empresa.num_ext} (${data.empresa.num_int})  <br>${data.empresa.colonia}, ${data.empresa.cp}  <br>${data.empresa.poblacion}, ${data.empresa.entfed}, ${data.empresa.pais}</td></tr></table><br><br><table style='width:650px; font-size:22px'><tr><td style='margin-left:auto; margin-right:auto; text-align:center'><b>Recuperación de contraseña</b></td></tr></table><br><table style='width:650px'><tr><td style='margin-left:auto; margin-right:auto'><b>Haz solicitado una nueva contraseña de acceso para STSHOP</b></td></tr></table><br><table style='border:1px solid #acb7c0; border-radius: 10px; width:650px; '><tr><td style='text-align: left; padding: 10px'><a href='${this.parametros.sitio}' target="_blank">Ingresa al sistema con los siguientes datos:</a><br><br>Usuario: ${data.cliente.usuario}<br>Contraseña: ${data.cliente.contrasena} <br><br>Posteriormente te recomendamos cambiar la contraseña en la seccion "Mi información"</td></tr></table><br><br><table style='width:650px;font-size:14px; font-style: oblique;'>  <tr><td style='width:480px;text-align: right'>  <img style='max-height: 50px;' src='https://stshop.club:85/stshopc.png  ' alt='No se encontro la imagen' /></td><td style='text-align: right'>STShop (<a href='http://www.superticket.mx'>superticket.mx</a>)</td>  </tr></table></div></body></html>`
        Email.send({
          Host : "smtp.ionos.mx",
          Username : "contacto@stshop.mx",
          Password : "Compart33461",
          To : data.cliente.email,
          From : "contacto@stshop.mx",
          Subject : `Recuperación de Contraseña STSHOP`,
          Body : mail
        }).then(
          message => alert('Se te ha enviado un correo con tu nueva contraseña')
        ).catch(err =>{
          alert(err);
        });
      },
      // getParametros() {
      //   this.resourceCliente.parametros()
      //     .then((response) => {
      //       const parametros = {};
      //       response.body.data.forEach((el) => {
      //         switch (el.descripcion) {
      //           case 'almacen':
      //             parametros.almacen = el.parametro;
      //             break;
      //           case 'pago':
      //             parametros.pago = el.parametro;
      //             break; 
      //           case 'envio':
      //             parametros.envio = el.parametro;
      //             break;
      //           case 'ruta_imagen':
      //             parametros.ruta_imagen = el.parametro;
      //             break;
      //           case 'existencia_negativa':
      //             parametros.existencia_negativa = el.parametro;
      //             break;
      //         }
      //         window.parametros = parametros;
      //       })
      //       localStorage.setItem('parametros', JSON.stringify(parametros));
      //     })
      //     .catch((err) => {
      //       this.$error(this, err);
      //     });
      //   this.closeModal('logInDialog');
      // },
      toggleSidenav() {
        this.$emit('TOGGLE_SIDEBAR');
      },
      goToCart() {
        this.$router.push({ name: 'carrito' });
        this.$refs.menuCarrito.close();
      },
      goToCatalogo() {
        this.$router.push({ name: 'inicio' });
      },
      goToMyCuenta() {
        this.$router.push({ name: 'cuenta' });
      },
      filterBySubstring() {
        this.$router.replace({ name: 'inicial', params: { descripcion: this.busqueda }});
      },
      registro() {
        this.usuarioRegistro.sTShop.usuario = this.usuarioRegistro.cliente.usuario
        this.usuarioRegistro.sTShop.email = this.usuarioRegistro.cliente.email
        this.usuarioRegistro.sTShop.RFC = this.usuarioRegistro.cliente.rfc
        this.resourceCliente.crear(this.usuarioRegistro)
        .then((response) => {
          const idusuario = response.body.idinterno;
            this.$toast.create('Cliente Registrado, inicie sesión', 'snack', 3E3);
            this.closeModal('registroDialog');
            this.checkCliente();
        })
        .catch((err) => {
          this.$toast.create('El Email o RFC ya existe', 'snack', 3E3);
        });
      },
      checkCliente() {
        if(localStorage.getItem('cliente')){
          this.cliente = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : {};
          this.$router.replace({ name: 'pagos'});
          
        } else {
          this.openModal("logInDialog");
        }
      },
    },
    mounted() {
      if(localStorage.getItem('cliente')){
        // this.cliente = JSON.parse(localStorage.getItem('cliente'));
        
        this.setCliente();
      }
      if(localStorage.getItem('parametros')){
        this.getParametros();
      }
      this.setCart();
      // this.logInAuth();
      // this.getParametros();
      this.parametros = localStorage.getItem('parametros') ? JSON.parse(localStorage.getItem('parametros')) : {ocultar_precios: 0};  
      this.empresa = localStorage.getItem('empresa') ? JSON.parse(localStorage.getItem('empresa')) : {};  
    },
  };
</script>
<style src="./Toolbar.scss" lang="scss"></style>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/shared-components/toolbar/Toolbar.vue